// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3y_QD","content":"GlobalSearch_content__239vd"};